import {LoadingIcon} from '~library/svg/LoadingIcon';

import './RegistryVendorLoading.sass';

export const RegistryVendorLoading = () => {
  return (
    <div className="registry-vendor-loading">
      <LoadingIcon className="suspense-fallback__spinning-icon" ratio={1.334} />
    </div>
  );
};
